// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDependentNameDto
 */
export interface IDependentNameDto {
    /**
     * 
     * @type {number}
     * @memberof IDependentNameDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDependentNameDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentNameDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentNameDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentNameDto
     */
    suffix?: string;
}

/**
 * Check if a given object implements the IDependentNameDto interface.
 */
export function instanceOfIDependentNameDto(value: object): value is IDependentNameDto {
    return true;
}

export function IDependentNameDtoFromJSON(json: any): IDependentNameDto {
    return IDependentNameDtoFromJSONTyped(json, false);
}

export function IDependentNameDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDependentNameDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
    };
}

export function IDependentNameDtoToJSON(json: any): IDependentNameDto {
    return IDependentNameDtoToJSONTyped(json, false);
}

export function IDependentNameDtoToJSONTyped(value?: IDependentNameDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
    };
}

